<template lang="pug">
div(:class="{'has-error': !item.valid, 'form-group': type != 'checkbox'}")
    template(v-if="['text', 'number'].includes(type)")
        .vfl-field.input-group(style='width: 100%;')
            input(type="text", required="", 
                  :class="numberClass",
                  v-model="item.value",
                  @focus="onFocus(item)",
                  @blur="onBlur(item)")
            span.field-underline
            label {{ label }}
    template(v-if="type === 'textarea'")
        .vfl-field.input-group(style='width: 100%;')
            textarea(required="", 
                     style="max-height: 401px;",
                     v-model="item.value",
                     @focus="onFocus(item)",
                     @blur="onBlur(item)")
            span.field-underline
            label {{ label }}
    template(v-else-if="type === 'checkbox'")
        .checkbox.clip-check.check-primary.checkbox-inline
            input(
                :id="id"
                type="checkbox", 
                v-model="item.value"
            )
            label(:for="id") {{ label }}
    template(v-else-if="type === 'phone'")
        .vfl-field.input-group(style='width: 100%;')
            the-mask(
                type='tel', mask="+7 (###) ###-##-##", 
                v-model="item.value",
                required="", 
                @focus.native="onFocus(item)",
                @blur.native="onBlur(item)"
            )
            span.field-underline
            label {{ label }}
    template(v-else-if="type === 'select'")
        v-select-styled(
            :class="{'fix-height-div': !multiple}",
            v-model="item.value",
            :on-search="onSearch",
            label='full_name',
            max-height="270px",
            :field-label="label",
            :options="itemsChoice", 
            :withPreloading="true",
            @focus="onFocus(item)",
            @blur="onBlur(item)"
        )

    span.help-block.error(v-if="!item.valid") {{ item.message }}
    span.help-inform-block(v-if="helpText")
        i.ti-help-alt.text-primary
        span(v-html="' ' + helpText")
</template>

<script>
import vSelectStyled from '@/components/vSelectStyled';
import { getAjaxSearchMethod } from '@/utils/vSelect';

import Inputmask from 'inputmask/dist/inputmask/inputmask';
import uuid4 from 'uuid/v4';

export default {
    name: 'Field',
    props: {
        type: {
            type: String,
            default: 'text'
        },
        label: {
            type: String,
            default: ''
        },
        item: Object,
        helpText: {
            default: null
        },
        /* Только для ``type`` === 'number' */
        // Возможное количество знаков после запятой
        precision: {
            type: Number,
            default: 0
        },
        /* Только для ``type`` === 'select' */
        multiple: {
            type: Boolean,
            default: false
        },
        searchPath: {
            type: String,
            default: ''
        }
        // itemsChoice: {
        //     type: Array,
        //     default: []
        // }
    },
    components: {
        vSelectStyled
    },
    mounted() {
        if (this.type === 'number') {
            let regex = '\\d{0,15}';
            if (this.precision) regex += `[.]{1}\\d{0,${this.precision}}`;

            let fields = document.getElementsByClassName(this.className);
            Inputmask({regex, placeholder: ''}).mask(fields);
        }
    },
    methods: {
        onFocus(item) {
            [item.valid, item.message] = [true, ''];

            if (this.type === 'phone') this.onPhoneFocus(item);

            this.$emit('focus');
        },
        onBlur(item) {
            if (this.type === 'phone') this.onPhoneBlur(item);

            this.$emit('blur');
        },
        onPhoneFocus(item) {
            if (!item.value) item.value = '+7 (';
        },
        onPhoneBlur(item) {
            if (item.value && item.value.length < 10) {
                [item.valid, item.message] = [false, 'Неверное значение'];
            }
        },
        onSearch: getAjaxSearchMethod()
    },
    data() {
        let data = {
            numberClass: {}
        };

        if (this.type === 'select') {
            data.itemsChoice = [];
        } else if (this.type === 'number') {
            data.className = `number-${uuid4().slice(0, 5)}`;
            data.numberClass[data.className] = true;
        } else if (this.type == 'checkbox') {
            data.id = `checkbox-${uuid4().slice(0, 5)}`;
        }

        return data;
    }
};
</script>

<style>
.fix-height-div .dropdown-toggle {
    max-height: 33px;
}
</style>



// WEBPACK FOOTER //
// src/components/core/Field.vue